import { Component, inject, Input } from "@angular/core";

import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import {
  CariButtonComponent,
  UIComponentsModule,
} from "@cariloop/ui-components";
import { DialogRef } from "@angular/cdk/dialog";

@Component({
  selector: "app-backup-mfa-codes-modal",
  imports: [
    MatDialogModule,
    MatIconModule,
    TranslateModule,
    UIComponentsModule,
    CariButtonComponent,
  ],
  templateUrl: "./backup-mfa-codes-modal.component.html",
  styleUrls: ["./backup-mfa-codes-modal.component.scss"],
})
export class BackupMfaCodesModalComponent {
  private dialogRef = inject(DialogRef);

  @Input() backupCodes: string[] = [];

  onClose(isMFAEnabled): void {
    this.dialogRef.close(isMFAEnabled);
  }

  copyToClipboard(): void {
    const codesText = this.backupCodes.join("\n");
    navigator.clipboard.writeText(codesText);
  }

  downloadCodes(): void {
    const csvContent = this.backupCodes.join("\n") + "\n";
    const blob = new Blob(["\ufeff", csvContent], {
      type: "text/csv;charset=utf-8;",
    });
    const link = document.createElement("a");

    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "backup-codes.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}
